import React, { useCallback, useContext, useState } from "react";
import FilterSecondPage_Kratos from "./FilterSecondPage_Kratos";
import TopkpisSecond_Kratos from "./TopkpisSecond_Kratos";
import TopkpisSecondMain_Kratos from "./TopkpisSecondMain_Kratos";
import "./Driveanalysis_Kratos";
import Header_Kratos from "../LayoutMain_Kratos/Header_Kratos";
import RealWorldBar_Kratos from "./DriveSecondPageCharts_Kratos/RealWorldBar_Kratos";
import NetEnergydBox_Kratos from "./DriveSecondPageCharts_Kratos/NetEnergydBox_Kratos";
import NetEnergyBar_Kratos from "./DriveSecondPageCharts_Kratos/NetEnergyBar_Kratos";
import Torquespeed_Kratos from "./DriveSecondPageCharts_Kratos/Torquespeed_Kratos";
import TorqueBox_Kratos from "./DriveSecondPageCharts_Kratos/TorqueBox_Kratos";
import AvgDDBar_Kratos from "./DriveSecondPageCharts_Kratos/AvgDDBar_Kratos";
import ModeUtilization_Kratos from "./DriveSecondPageCharts_Kratos/ModeUtilization_Kratos";
import moment from "moment";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";
import RealWorldBox_Kratos from "./DriveSecondPageCharts_Kratos/RealWorldBox_Kratos";

function PageSecond_Kratos(props) {
  const [secondPageState, setSecondPageState] = useState({
    startDate: props.gloablfilter.startDate,
    endDate: props.gloablfilter.endDate,
    vin_num: props.gloablfilter.VIN_NUM.toString(),
    soc_per: props.gloablfilter.SOC,
    CITY: props.gloablfilter.CITY,
    DEPO: props.gloablfilter.DEPO,
  });
  const [chartTypeBox, setChartBoxSelected] = useState("netenergybox");
  const [chartType, setChartSelected] = useState("netenergy");
  const filterSubmited = useCallback((data) => {
    setSecondPageState(data);
  }, []);

  const changeNetBox = (selectedOption) => {
    setChartBoxSelected(selectedOption);
  };
  const changeNet = (selectedOption) => {
    setChartSelected(selectedOption);
  };

  const pageChange = useCallback((data) => {
    props.pageChange();
  }, []);
  const loggedInUser = useSelector(selectLoggedInUser);
  return (
    <>
      <FilterSecondPage_Kratos
        onsubmit={filterSubmited}
        pageChange={pageChange}
        secondPageState={secondPageState}
      />

      <div className="container-fluid kratosdrpg1 pb-1">
        <TopkpisSecond_Kratos
          gloablfilter={secondPageState}
          apiend="kratos_drive_second/topkpis"
        />
        <TopkpisSecondMain_Kratos
          gloablfilter={secondPageState}
          apiend="kratos_drive_second/topkpismain"
        />
        <section className="graphs kratosdrpg1">
          <div className="row mt-4 mb-3 equal-cols">
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="v-title chartbox chartbox_kratos">
                <div className="titlebg_kratos p-2">Real World Range Boxplot</div>
                <div className="chartHGT_Kratos_Kratos">
                  <RealWorldBox_Kratos
                    gloablfilter={secondPageState}
                    apiend="kratos_drive_second/realworldrangebox_bus"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="v-title chartbox chartbox_kratos">
                <div className="titlebg_kratos p-2">
                  Real World Range Distribution
                </div>
                <div className="chartHGT_Kratos">
                  <RealWorldBar_Kratos
                    apiend="kratos_drive_second/realworldrange_bus"
                    gloablfilter={secondPageState}
                  ></RealWorldBar_Kratos>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="v-title chartbox chartbox_kratos">
                <div className="titlebg_kratos p-2">Net Energy Boxplot</div>
                <div className="chartHGT_Kratos">
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <select
                      className="form-select form-select-sm"
                      aria-label=".form-select-sm example"
                      onChange={(event) => changeNetBox(event.target.value)}
                      value={chartTypeBox}
                    >
                      <option value="netenergybox">Kwh/km</option>
                      <option value="netkwhbox">kWh</option>
                    </select>
                  </div>
                  {chartTypeBox === "netenergybox" ? (
                    <NetEnergydBox_Kratos
                      gloablfilter={secondPageState}
                      apiend="kratos_drive_second/energyconsuptionbox_whperkm_bus"
                    ></NetEnergydBox_Kratos>
                  ) : (
                    <NetEnergydBox_Kratos
                      gloablfilter={secondPageState}
                      apiend="kratos_drive_second/energyconsuptionbox_kwh_bus"
                    ></NetEnergydBox_Kratos>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12">
              <div className="v-title chartbox chartbox_kratos">
                <div className="titlebg_kratos p-2">Net Energy Consumption</div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                  <select
                    className="form-select form-select-sm"
                    aria-label=".form-select-sm example"
                    onChange={(event) => changeNet(event.target.value)}
                    value={chartType}
                  >
                    <option value="netenergy">Kwh/km</option>
                    <option value="netkwh">kWh</option>
                  </select>
                </div>

                <div className="chartHGT_Kratos">
                  {chartType === "netenergy" ? (
                    <NetEnergyBar_Kratos
                      apiend="kratos_drive_second/energyconsuptionbar_whperkm_bus"
                      gloablfilter={secondPageState}
                    ></NetEnergyBar_Kratos>
                  ) : (
                    <NetEnergyBar_Kratos
                      apiend="kratos_drive_second/energyconsuptionbar_kwh_bus"
                      gloablfilter={secondPageState}
                    ></NetEnergyBar_Kratos>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4 mb-3 equal-cols">
            {/* {loggedInUser.flagForHideShow === "ERC" && (
              <div className="col-lg-3 col-md-6 col-sm-12">
                <Torquespeed_Kratos
                  apiend="kratos_drive_second/motortorque_bus"
                  gloablfilter={secondPageState}
                ></Torquespeed_Kratos>
              </div>
            )}
            {loggedInUser.flagForHideShow === "ERC" && (
              <div className="col-lg-3 col-md-6 col-sm-12">
                <TorqueBox_Kratos
                  apiend="kratos_drive_second/motortorque_bus"
                  gloablfilter={secondPageState}
                ></TorqueBox_Kratos>
              </div>
            )} */}
            <div
              className={
                loggedInUser.flagForHideShow === "ERC"
                  ? "col-lg-6 col-md-6 col-sm-12"
                  : "col-lg-6 col-md-4 col-sm-12"
              }
            >
              <div className="v-title chartbox chartbox_kratos">
                <div className="titlebg_kratos drive_last">
                  SoC Discharge/Cycle Analysis
                </div>
                <div className="chartHGT_Kratos">
                  <AvgDDBar_Kratos
                    apiend="kratos_drive_second/socdischarge_bus"
                    gloablfilter={secondPageState}
                  ></AvgDDBar_Kratos>
                </div>
              </div>
            </div>

            <div
              className={
                loggedInUser.flagForHideShow === "ERC"
                  ? "col-lg-6 col-md-6 col-sm-12"
                  : "col-lg-6 col-md-4 col-sm-12"
              }
            >
              <div className="v-title chartbox chartbox_kratos">
                <div className="titlebg_kratos drive_last">
                  Discharge Cycle vs Range
                </div>
                <div className="chartHGT_Kratos">
                  <ModeUtilization_Kratos
                    gloablfilter={secondPageState}
                    apiend="kratos_drive_second/socdischarge_vs_range_bus"
                  ></ModeUtilization_Kratos>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
export default PageSecond_Kratos;
